import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Blackwood Castle';
    src: url('/font/Blackwood-Castle.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  :root {
    --royal-blue: #000157;
    --gold: #b37b00;
    --shine-duration: 2.5s;
    --dark-gray:hsl(0, 0.00%, 6.40%);
    --light-gray: #f5f5f5;
    --white: #fff;
    --black: #000;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Arial', sans-serif;
    background-color: var(--dark-gray);
    color: var(--white);
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5 {
    font-family: 'Blackwood Castle', serif;
    color: var(--gold);
    font-weight: 300;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  .section {
    padding: 4rem 2rem;
  }

  @keyframes shine {
  to {
    background-position: 200% center;
  }
}

  .container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .section-title {
    font-size: 3rem;
    text-align: center;
    margin-bottom: 2rem;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  }

  .neo-baroque {
    background-color: var(--royal-blue);
    border: 2px solid var(--gold);
    box-shadow: 0 0 15px rgba(255, 215, 0, 0.3);
    position: relative;
  }

  .neo-baroque::before {
    content: '';
    position: absolute;
    top: -5px;
    left: -5px;
    right: -5px;
    bottom: -5px;
    border: 1px solid var(--gold);
    pointer-events: none;
    opacity: 0.5;
  }

  .btn {
    background-color: var(--royal-blue);
    color: var(--gold);
    border: 2px solid var(--gold);
    padding: 0.75rem 1.5rem;
    font-family: 'Blackwood Castle', serif;
    font-size: 1.2rem;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .btn:hover {
    background-color: var(--gold);
    color: var(--royal-blue);
  }

  /* Responsive styles */
  @media (max-width: 768px) {
    .section {
      padding: 3rem 1rem;
    }

    .section-title {
      font-size: 2.5rem;
    }
  }

  @media (max-width: 480px) {
    .section {
      padding: 2rem 1rem;
    }

    .section-title {
      font-size: 2rem;
    }
  }
`;

export default GlobalStyles;
